var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleBedIconKlm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6.66634V4.66634C11.9998 3.92996 11.4029 3.33301 10.6665 3.33301H5.33317C4.59679 3.33301 3.99984 3.92996 3.99984 4.66634V6.66634C3.26346 6.66634 2.6665 7.26329 2.6665 7.99967V11.333H3.55317L3.99984 12.6663H4.6665L5.11317 11.333H10.8865L11.3332 12.6663H11.9998L12.4465 11.333H13.3332V7.99967C13.3332 7.26329 12.7362 6.66634 11.9998 6.66634ZM7.33317 6.66634H5.33317V4.66634H7.33317M10.6665 6.66634H8.6665V4.66634H10.6665V6.66634Z",
    fill: "#00A1DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_181_15489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 12,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6.66634V4.66634C11.9998 3.92996 11.4029 3.33301 10.6665 3.33301H5.33317C4.59679 3.33301 3.99984 3.92996 3.99984 4.66634V6.66634C3.26346 6.66634 2.6665 7.26329 2.6665 7.99967V11.333H3.55317L3.99984 12.6663H4.6665L5.11317 11.333H10.8865L11.3332 12.6663H11.9998L12.4465 11.333H13.3332V7.99967C13.3332 7.26329 12.7362 6.66634 11.9998 6.66634ZM7.33317 6.66634H5.33317V4.66634H7.33317M10.6665 6.66634H8.6665V4.66634H10.6665V6.66634Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_181_15489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6663 -8.66699H-8.66699V24.6663H24.6663V-8.66699Z",
    fill: "#00A1DE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleBedIconKlm);
export default __webpack_public_path__ + "static/media/double-bed-icon-klm.33812ac264ca79cb6df68e402bb8f5f2.svg";
export { ForwardRef as ReactComponent };